import { styled } from "@mui/material";
import { editorName } from "../classes.js";
const EditorScroller = styled("div", {
  name: editorName,
  slot: "EditorScroller",
  overridesResolver: (_, styles) => styles.editorScroller
})(({ theme, ownerState }) => {
  const allChildren = "*";
  return {
    display: "flex",
    flexGrow: 1,
    overflow: "auto",
    position: "relative",
    flexDirection: "column",
    ...ownerState?.disabled && {
      backgroundColor: (theme.vars ?? theme).palette.grey[100],
      [allChildren]: {
        color: (theme.vars ?? theme).palette.action.disabled
      }
    }
  };
});
export {
  EditorScroller
};
//# sourceMappingURL=EditorScroller.js.map
